import React from "react";
import FormattedNumber from "@/shared/components/FormattedNumber";
import { TableWrap, Table, Th, Td, FlexRow } from "./styledComponents";
import styled from "styled-components";

const SortableTh = styled(Th)`
  cursor: pointer;
  user-select: none;
  position: relative;
  padding-right: 20px;
  transition: color 0.2s ease;
  &:hover {
    color: #5ce9ff;
  }
  ${({ active }) => active && `
    color: #5ce9ff;
  `}
`;

const SortIndicator = styled.span`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: ${({ active }) => active ? "#5ce9ff" : "#475569"};
  ${({ active }) => active && `
    opacity: 1;
  `}
  ${({ active }) => !active && `
    opacity: 0.5;
  `}
`;

function WalletTable({
  items,
  wallet,
  pendingBalance,
  activity,
  sortColumn,
  sortDirection,
  onSort,
  onRowClick,
  onDepositClick,
  onWithdrawClick,
  onInfoClick,
}) {
  const getSortIndicator = (column) => {
    if (sortColumn !== column) {
      return <SortIndicator active={false}>↕</SortIndicator>;
    }
    return (
      <SortIndicator active={true}>
        {sortDirection === "asc" ? "↑" : "↓"}
      </SortIndicator>
    );
  };

  return (
    <TableWrap style={{ marginTop: "16px" }}>
      <Table>
        <thead>
          <tr>
            <SortableTh
              active={sortColumn === "symbol"}
              onClick={() => onSort && onSort("symbol")}
            >
              Symbol
              {getSortIndicator("symbol")}
            </SortableTh>
            <SortableTh
              active={sortColumn === "price"}
              onClick={() => onSort && onSort("price")}
            >
              Price
              {getSortIndicator("price")}
            </SortableTh>
            <SortableTh
              active={sortColumn === "qty"}
              onClick={() => onSort && onSort("qty")}
            >
              Qty
              {getSortIndicator("qty")}
            </SortableTh>
            <SortableTh
              active={sortColumn === "balance"}
              onClick={() => onSort && onSort("balance")}
            >
              Balance
              {getSortIndicator("balance")}
            </SortableTh>
            {wallet === "Virtual" && (
              <SortableTh
                active={sortColumn === "upcoming"}
                onClick={() => onSort && onSort("upcoming")}
              >
                Upcoming
                {getSortIndicator("upcoming")}
              </SortableTh>
            )}
            <Th>Actions</Th>
          </tr>
        </thead>
        <tbody>
          {items.map((a) => {
            const pendingCoin = wallet === "Virtual" && pendingBalance
              ? pendingBalance.find((coin) => coin.symbol === a.symbol)
              : null;
            const isActive = activity && activity.wallet === wallet && activity.symbol === a.symbol;
            return (
              <tr
                key={`${wallet}-${a.symbol}`}
                onClick={() => onRowClick && onRowClick(wallet, a.symbol)}
                style={{
                  cursor: onRowClick ? "pointer" : "default",
                  backgroundColor: isActive ? "rgba(0, 247, 210, 0.1)" : "transparent",
                  transition: "background-color 0.2s ease",
                }}
              >
                <Td>{a.symbol}</Td>
                <Td>
                  <FormattedNumber value={a.price || 0} symbol="$" maxDecimals={2} />
                </Td>
                <Td>
                  <FormattedNumber value={a.qty || 0} maxDecimals={8} />
                </Td>
                <Td>
                  <FormattedNumber value={a.balance || 0} symbol="$" maxDecimals={3} />
                </Td>
                {wallet === "Virtual" && (
                  <Td>
                    {pendingCoin && pendingCoin.quantity ? (
                      <FormattedNumber value={parseFloat(pendingCoin.quantity)} maxDecimals={8} />
                    ) : (
                      "--"
                    )}
                  </Td>
                )}
                <Td>
                  <FlexRow gap={6}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDepositClick(a);
                      }}
                      style={{
                        background: "none",
                        border: "1px solid #5ce9ff",
                        color: "#5ce9ff",
                        borderRadius: "8px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        fontSize: "11px",
                      }}
                    >
                      Deposit
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onWithdrawClick(a);
                      }}
                      style={{
                        background: "none",
                        border: "1px solid #5ce9ff",
                        color: "#5ce9ff",
                        borderRadius: "8px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        fontSize: "11px",
                      }}
                    >
                      Withdraw
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onInfoClick(a);
                      }}
                      style={{
                        background: "none",
                        border: "1px solid #5ce9ff",
                        color: "#5ce9ff",
                        borderRadius: "8px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        fontSize: "11px",
                      }}
                    >
                      Info
                    </button>
                  </FlexRow>
                </Td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableWrap>
  );
}

export default WalletTable;

